import { HTML_FILE, PDF_FILE, ZIP_FILE } from 'components/CreateUpdateSiteModal/interface'
import JSZip from 'jszip'

const metadataFilesPath = ['__MACOSX', '.DS_Store', 'Thumbs.db', '/._']

export const findHtmlFilesInZipFile = async (file) => {
  let htmlFiles = []
  try {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)

    await new Promise((resolve, reject) => {
      reader.onload = resolve
      reader.onerror = reject
    })

    const content = reader.result
    const zip = await JSZip.loadAsync(content)

    zip.forEach((path) => {
      if (path.endsWith('.html') && !metadataFilesPath.some((metadataFilePath) => path.includes(metadataFilePath))) {
        htmlFiles.push(path)
      }
    })
  } catch (error) {
    console.log(error)
  }

  return htmlFiles
}

export const isIndexFile = (htmlFiles) => {
  if (htmlFiles.length > 1) return htmlFiles.some((htmlFile) => htmlFile.split('/')[1] === 'index.html')

  return true
}

export const getFileType = (fileName) => {
  if (fileName?.endsWith('.pdf')) {
    return PDF_FILE
  } else if (fileName?.endsWith('.zip')) {
    return ZIP_FILE
  } else if (fileName?.endsWith('.html')) {
    return HTML_FILE
  } else {
    return null
  }
}
